/* eslint-disable camelcase */
import { Card, Col, Row } from 'react-bootstrap';
import { useParams } from 'react-router-dom';

import classNames from 'classnames';
import dateFormat from 'dateformat';

import CreateTicketCommentForm from '@components/Forms/CreateTicketCommentForm/CreateTicketCommentForm';
import { DefaultSpinnerCenter } from '@components/Loader/Loader';
import { TicketDetailsTable } from '@components/Tickets/TicketsTable';
import { Page404, Page500 } from '@containers/ErrorPages';
import { ticketApi } from '@reducers/tickets/tickets';

export const TicketDetails = () => {
  const { ticketID } = useParams();
  const { data, isError, error, isLoading, isFetching } =
    ticketApi.useGetDetailsQuery({
      ticketID,
    });
  if (isLoading || isFetching) {
    return <DefaultSpinnerCenter />;
  }
  if (isError && error.status === 404) {
    return <Page404 />;
  }
  if (isError) {
    return <Page500 />;
  }
  const { comments, attachments } = data;
  return (
    <>
      <Row className="mb-3">
        <Col md={12}>
          <h4 className="border-bottom mb-3 mt-3">
            #{ticketID} Ticket details
          </h4>
          <TicketDetailsTable data={data} />
        </Col>
      </Row>
      <Row>
        <Col md={10}>
          <h4 className="border-bottom mb-3">Comments:</h4>
          {comments
            ? comments.map((item) => {
                const date = new Date(item.created_at);
                const created_at = dateFormat(date, 'defaultDateTime');
                return (
                  <Card className="mb-2" key={created_at}>
                    <Card.Header
                      className={classNames('bg-didxl', 'text-white')}
                    >
                      <Row>
                        <Col>
                          <div className="text-start fw-bold">
                            {item.author}
                          </div>
                        </Col>
                        <Col>
                          <div className="text-end fst-italic">
                            {created_at}
                          </div>
                        </Col>
                      </Row>
                    </Card.Header>
                    <Card.Body>{item.body}</Card.Body>
                  </Card>
                );
              })
            : null}
        </Col>
        <Col md={2}>
          <Card>
            <Card.Header className="bg-didxl text-white">
              Attached Files:
            </Card.Header>
            <Card.Body>
              {attachments
                ? attachments.map((item) => (
                    <div key={item.content_url}>
                      <a
                        className="text-decoration-none"
                        href={item.content_url}
                      >
                        {item.file_name}
                      </a>
                    </div>
                  ))
                : null}
            </Card.Body>
          </Card>
        </Col>
      </Row>
      {data.status !== 'closed' && data.status !== 'solved' ? (
        <Row>
          <Col md={10}>
            <Card className="mb-2">
              <Card.Header>Post comment</Card.Header>
              <Card.Body>
                <CreateTicketCommentForm />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      ) : null}
    </>
  );
};
